
import Vue from "vue";
import { NewToiletsApiFunc, setAccessToken } from "@/api";
import { Toilet } from "@/models";

import ToiletList from "./components/ToiletList.vue";
import SearchForm from "@/components/BaseSearchForm.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";

export type FilterCondition = {
  word?: string;
  status?: string;
};

export type DataType = {
  toilets: Array<Toilet>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
};

export default Vue.extend({
  name: "ToiletListScreen",

  data(): DataType {
    return {
      toilets: [],
      filterCondition: {
        word: "",
        status: "",
      },
      totalPage: 0,
      currentPage: 0,
    };
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },

  mounted() {
    this.fetchToilets();
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === "true") {
        this.fetchToilets(this.currentPage);
      }
    },
  },

  components: {
    TheTemplate,
    SearchForm,
    ToiletList,
    Pager,
  },

  methods: {
    async fetchToilets(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
        status: this.filterCondition.status,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewToiletsApiFunc().listToilets(companyId, filterString, page);

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchToilets(page);
        });
        return;
      }

      this.toilets = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition);
    },

    changePage(page: number): void {
      this.fetchToilets(page);
    },
  },
});
